module.exports = require("dyna-switch");